<template>
    <div class="projects-overview" id="projects-overview">
        <div class="projects-overview__header">
            <h2>Projektübersicht</h2>
        </div>
        <!-- filter bar start -->
        <projects-overview-filter-bar :filters="filters" @changed="setFilters" />
        <!-- filter bar end -->
        <div class="projects-overview-content">
            <transition-group name="teaser" tag="div" class="projects-overview-content__inner">
                <project-teaser
                    v-for="project in projects"
                    :key="project.id"
                    :project="project"
                />
            </transition-group>
        </div>
        <div class="projects-overview-more-trigger" v-if="!showAllProjects && filteredProjects.length > 12">
            <button class="btn btn--blue btn--xl" @click="toggleAllProjects">
                Weitere Projekte anzeigen
            </button>
        </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'
import sortBy from 'lodash.sortby'

import { SORT_BY_DATE, SORT_BY_HEARTS } from '@/types'

import ProjectTeaser from '@/components/ProjectTeaser'
import ProjectsOverviewFilterBar from '@/components/ProjectsOverviewFilterBar'

export default {
    name: 'ProjectsOverview',

    components: {
        ProjectTeaser,
        ProjectsOverviewFilterBar
    },

    data () {
        return {
            showAllProjects: false
        }
    },

    computed: {
        ...mapState({
            storedProjects: state => state.projects,
            filters: state => state.filters
        }),

        sortedProjects () {
            //  make local ref
            let projects = this.storedProjects
            // sort by
            projects = sortBy(projects, [project => {
                const key = this.filters.sortBy
                switch (key) {
                case SORT_BY_HEARTS:
                    return project[SORT_BY_HEARTS]
                case SORT_BY_DATE:
                    return new Date(project[SORT_BY_DATE].date).valueOf()
                default:
                    console.log('Could not find sort key', this.filters.sortBy, SORT_BY_HEARTS, SORT_BY_DATE)
                }
            }]).reverse()

            return projects
        },

        filteredProjects () {
            let projects = this.sortedProjects
            // filter archived
            if (!this.filters.archived) {
                projects = projects.filter(project => {
                    return !project.archiviert
                })
            }

            return projects
        },

        projects () {
            // by default cut it to 12
            if (!this.showAllProjects) {
                return this.filteredProjects.slice(0, 12)
            }

            return this.filteredProjects
        }
    },

    methods: {
        toggleAllProjects () {
            this.showAllProjects = !this.showAllProjects
        },

        setFilters (filters) {
            this.$store.commit('setFilters', filters)
        }
    }
}
</script>

<style>
.project-teaser {
    transition: all 1s;
    z-index: 2;
}
.teaser-enter, .teaser-leave-to
/* .teaser-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: scale(0.7);
}
.teaser-leave-active {
    z-index: 1;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectsOverview.vue